export default "__VITE_ASSET__95a5db70__"